import * as React from 'react'
import styled, { css } from 'styled-components'

import * as ds from '@bob/design-system'
import * as hooks from '@bob/hooks'

type ResultListProps<ITEM> = {
  engine: hooks.useSearchEngine.SearchEngine<ITEM>
  loading: React.ReactNode
  children: (props: { item: ITEM }) => React.ReactNode
} & Omit<React.HTMLAttributes<HTMLUListElement>, 'children'>

export function ResultList<ITEM>({
  loading,
  children,
  engine: { result, ready },
  ...ulProps
}: ResultListProps<ITEM>): React.ReactElement {
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    if (isClient === false) {
      setIsClient(typeof window !== 'undefined')
    }
  }, [])

  if (result.page.length === 0) {
    return <p>Pas de résultats</p>
  }

  return (
    <>
      {(!isClient || result.status === 'request' || !ready) && <Grid>{loading}</Grid>}
      {result.status === 'success' && ready && (
        <Grid {...ulProps} hidden={!isClient}>
          {result.page.map((item) => {
            return children({ item })
          })}
        </Grid>
      )}
    </>
  )
}

const Grid = styled.ul<{ hidden?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 7%;
  justify-content: center;
  width: 100%;

  ${({ hidden }) =>
    hidden &&
    css`
      height: 0px;
      overflow: hidden;
      position: fixed;
      top: 0;
      visibility: hidden;
      z-index: -1;
    `}

  & > * {
    margin-bottom: 30px;
  }

  @media screen and (${ds.breakpoint.LAPTOP}) {
    display: grid;
    grid-gap: 30px;
    grid-template-columns: repeat(2, 1fr);
    justify-items: initial;
    row-gap: 30px;

    & > * {
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: 1240px) {
    grid-template-columns: repeat(3, 1fr);
  }
`
